import { notification, Typography } from "antd";
import Router from "next/router";
import { G_Button } from "../Button";

export const ErrorMessage = (
  text: string | undefined,
  type: "error" | "info" = "error",
  traceId?: string
) => {
  const handleReportBug = () => {
    const query = { ...Router.query, traceId };
    Router.push({ pathname: Router.pathname, query }, undefined, {
      shallow: true
    });
  };

  return (
    <>
      {notification[type]({
        message: `${type?.charAt(0)?.toUpperCase()}${type.slice(1)}`,
        description: (
          <>
            {text || "Something is wrong. Please report this error"}
            {traceId && (
              <Typography.Text
                copyable={{ text: traceId }}
                type="secondary"
                style={{ display: "block", fontSize: 12, marginTop: 8 }}
              >
                Trace: {traceId}
              </Typography.Text>
            )}
          </>
        ),
        btn: traceId ? (
          <G_Button size="small" type="primary" onClick={handleReportBug}>
            Report Bug
          </G_Button>
        ) : undefined,
        placement: "bottomRight",
        duration: 10
      })}
    </>
  );
};
